/* eslint-disable no-unused-vars */
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from 'theme-ui'

import Box from '/components/Commons/Box'
import VotePlayer from '/components/Commons/VotePlayer'
import tracking from '/lib/tracking'
import getTrackingInfo from '/utils/getTrackingInfo'

const Players = ({
  locale,
  players,
  voteResponse,
  onVoteClick,
  votePlayerId,
  votePlayerData,
  ...props
}) => {
  const { sendCSMEvent } = tracking()
  const { cta, statsCaption, players: playerList } = players

  return (
    <Box boxStyle="playersListContainer">
      {playerList &&
        !votePlayerId &&
        playerList.map((player, index) => (
          <VotePlayer
            callForAction={cta}
            statsTitle={statsCaption}
            {...props}
            onVoteClick={() => {
              sendCSMEvent(getTrackingInfo('potmVote'), locale)
              onVoteClick(player.id)
            }}
            key={index}
            player={player}
          />
        ))}

      {votePlayerId && (
        <VotePlayer
          callForAction={cta}
          votePlayerId={votePlayerId}
          {...props}
          player={votePlayerData}
        />
      )}
    </Box>
  )
}
export default Players
